import { Copy, CopySuccess } from 'iconsax-reactjs';
import { useCallback } from 'react';
import { useCopyToClipboard } from 'react-use';
import { useLazyValue } from './react';

export const useCopy = (content?: string) => {
  const [copyState, copy] = useCopyToClipboard();
  const lazyState = useLazyValue(copyState, 1000);

  const handleClick = useCallback(() => {
    copy(content ?? '');
  }, [copy, content]);

  return {
    children:
      copyState !== lazyState && copyState.value ? (
        <CopySuccess size={16} className="text-content-positive" />
      ) : (
        <Copy size={16} />
      ),

    disabled: !content || (copyState !== lazyState && !!copyState.value),
    onClick: handleClick,
  };
};
